<template>
  <div id="insertInformation" class="flex-column">
    <div class="mobile-head">
      <i class="back iconfont icon-arrow-left"></i>
      <h1>核酸检测点忙闲数据上报</h1>
    </div>
    <div class="flex-occupied-1">
      <div class="mobile-content">
        <!-- 表单 -->
        <van-form ref='form' label-width="7.6em" abel-align="left">
<!--          <h3 class="first-level-title">核酸检测点忙闲数据上报</h3>-->
          <van-field
            readonly
            required
            clickable
            size="large"
            v-model="accountForm.bankName"
            label="机构名称:"
            @click="showBank = true"
            placeholder="请选择机构名称"
            style="border-bottom:0.001rem solid #DCDCDC;padding-top: 0.5rem"
            :rules="[{ required: true, message: '请选择机构名称' }]"
          ></van-field>

          <van-field
            readonly
            v-model="accountForm.address"
            label="所在区:"
            style="border-bottom:0.001rem solid #DCDCDC;padding-top: 0.5rem"
            placeholder="所在区"
          ></van-field>
          <van-field
            readonly
            v-model="accountForm.detailAddress"
            label="详细地址:"
            style="border-bottom:0.001rem solid #DCDCDC;padding-top: 0.5rem"
            placeholder="详细地址"
          ></van-field>
          <van-field
            readonly
            v-model="accountForm.username"
            style="border-bottom:0.001rem solid #DCDCDC;padding-top: 0.5rem"
            label="填报人姓名:"
            placeholder="填报人姓名"
          ></van-field>
          <van-field
            required
            v-model="accountForm.total"
            size="large"
            type="number"
            maxlength="4"
            label="当前排队总人数:"
            placeholder="请输入"
            style="font-size: large;border-bottom:0.001rem solid 	#DCDCDC;padding-top: 0.5rem"
            :rules="[{ required: true, message: '请输入当前排队总人数' }]"
          ></van-field>
          <button @click="confirm" class="confirm-btn">提交</button>
        </van-form>
      </div>
      <!-- 选择机构名称 -->
      <van-popup v-model="showBank" position="bottom">
        <van-picker
          item-height=40
          show-toolbar
          :columns="bankList"
          @confirm="selectBank"
          @cancel="showBank = false"
        />
      </van-popup>
      <van-overlay :show="overlayShow" @click="show = false" >
        <div class="loading">
          <van-loading text-size="25px" color="#cbb486" size="100px" :vertical="true" style="color: #cbb486">
            <span style="color: #cbb486">正在提交...</span>
          </van-loading>
        </div>
      </van-overlay>
    </div>
  </div>
</template>

<script>
import {isEmpty} from "../utils";
import {Dialog} from "vant";

export default {
  data() {
    return {
      accountForm: {
        bankName: '',
        address: '',
        detailAddress: '',
        username: '',
        total: '',
        stPlaceId: ''
      },
      resData: [],
      bankList: [],
      showBank: false,
      overlayShow: false,
      pageFrom: 'nucleicAcidReport'
    }
  },
  methods: {
    selectBank(val) {
      this.accountForm.bankName = val
      this.resData.map(accountFormObj => {
        if (accountFormObj.stPlaceName === val) {
          this.accountForm.address = accountFormObj.stArea
          this.accountForm.detailAddress = accountFormObj.stPlaceAddress
          this.accountForm.stPlaceId = accountFormObj.stPlaceId
        }
      })
      this.showBank = false
    },
    validateNum(){
      if(this.accountForm.total>1000){
        this.$toast.fail("最大值为1000")
        this.accountForm.total = ''
        return false
      }else {
        return true
      }
    },
    confirm() {
      this.$refs.form.validate().then(() => {
      if (this.validateNum())  {
        Dialog.confirm({
          title: '确认',
          message: '确定要提交么',
        })
          .then(() => {
            this.reportQueueInfo()
          })
          .catch(() => {
            // on cancel
          });
      }
      }).catch(() => {
        this.$toast.fail('请填写必填项')
      })

    },
    async fetchAuthDetecPlace() {
      try {
        const res = await this.$axios.post('/dev/convidDetec/fetchAuthDetecPlace', {})
        if (res.status === 200) {
          res.data.map(dataObj => this.bankList.push(dataObj.stPlaceName))
          this.resData = res.data
        } else {
          this.$toast.fail(res.msg)
        }
      } catch (e) {
        console.log(e)
      }
    },
    async reportQueueInfo() {
      this.overlayShow = true;
      try {
        const res = await this.$axios.post('/dev/convidDetec/reportQueueInfo', {
          stPlaceId: this.accountForm.stPlaceId, // 办理点id
          nmQueueNum: this.accountForm.total  //排队人数
        })
        if (res.status === 200) {
          this.$toast.success("上报成功")
          this.overlayShow = false;
          await this.$router.push({
            path: '/nucleic-successful',
            query: {
              stPlaceId:this.accountForm.stPlaceId
            }
          })
          this.cleanFrom()
        } else {
          this.overlayShow = false;
          this.$toast.fail(res.msg)
          this.cleanFrom()

        }
      } catch (e) {
        console.log(e)
      }
    },
    async getUserInfoByToken() {
      try {
        const res = await this.$axios.post('/forwarder/login/getUserInfoByToken', {
          access_token: this.$route.query.access_token
        })
        if (res.status === '200') {
          this.accountForm.username = res.userName
          sessionStorage.setItem('userName', res.userName)
        }
      } catch (e) {
        console.log('获取用户信息error')
      }
    },
    jumpToMobile() {
      window.location.href = '/forwarder/redirect/jumpToMobile?pageFrom=' + this.pageFrom
    },
    cleanFrom() {
      this.accountForm.stPlaceId = ''
      this.accountForm.detailAddress = ''
      this.accountForm.total = ''
      this.accountForm.address = ''
      this.accountForm.bankName = ''
    }
  },
  async created() {
    document.title=''
    if (isEmpty(sessionStorage.getItem('userName'))) {
      if (this.$route.query.access_token) {
        await this.getUserInfoByToken()
      } else {
        this.jumpToMobile()
      }
    } else {
      this.accountForm.username = sessionStorage.getItem('userName')
    }
    if (this.accountForm.username) {
      await this.fetchAuthDetecPlace()
    }
  }
}
</script>

<style scoped>
.flex-column {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.flex-occupied-1 {
  flex: 1;
  overflow-y: auto;
}

/* 主题内容 */
.mobile-content {
  padding: 0 .683rem /* 32/46.875 */;
}

.mobile-head {
  display: flex;
  align-items: center;
  width: 100%;
  height: 2.133rem /* 100/46.875 */;
  text-align: center;
  z-index: 9999;
  background-color: #eee6d1;
}

.mobile-head .back {
  width: 1.707rem /* 80/46.875 */;
  height: 100%;
  font-size: .768rem /* 36/46.875 */;
  line-height: 2.133rem /* 100/46.875 */;
}

.mobile-head h1 {
  margin: 0;
  flex: 1;
  height: 100%;
  font-size: .64rem /* 30/46.875 */;
  line-height: 2.133rem /* 100/46.875 */;
  padding-right: 1.707rem /* 80/46.875 */;
}

/* 一级标题 */
.first-level-title {
  font-size: .683rem /* 32/46.875 */;
  font-weight: 700;
  line-height: 1;
  padding: .683rem /* 32/46.875 */ 0;
  margin: 0;
}

.first-level-title .tip {
  font-size: .512rem /* 24/46.875 */;
  font-weight: 400;
}

.confirm-btn {
  width: 100%;
  height: 2.048rem /* 96/46.875 */;
  font-size: .683rem /* 32/46.875 */;
  line-height: 2.048rem /* 96/46.875 */;
  padding: 0;
  margin: .683rem /* 32/46.875 */ 0;
  outline: none;
  border: none;
  color: rgba(255, 255, 255, 1);
  border-radius: .171rem /* 8/46.875 */;
  background: linear-gradient(to right, #e4c995, #b9916a);
}
.loading {
  position: fixed;
  z-index: 9999;
  width: 100%;
  height: 100%;
  /*background: rgba(255, 255, 255, 0.5);*/
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
